// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uo4FbIuV7qM0JFtzzwo9{align-items:center;gap:8px;display:flex}.jeKR64tUre497hFwzWX3{flex-direction:column;gap:4px;margin-top:32px;padding:0 24px;display:flex}.jeKR64tUre497hFwzWX3 .D0FVjsNnUsIrxJt0ikGG{grid-template-columns:130px auto;align-items:flex-start;display:grid}.jeKR64tUre497hFwzWX3 .D0FVjsNnUsIrxJt0ikGG .Wu2d3y3HMoUClpfiTLqB{min-height:32px;color:var(--content-primary-tertiary);align-items:center;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapPlaceholder": `uo4FbIuV7qM0JFtzzwo9`,
	"sendParamsWrapper": `jeKR64tUre497hFwzWX3`,
	"grid": `D0FVjsNnUsIrxJt0ikGG`,
	"label": `Wu2d3y3HMoUClpfiTLqB`
};
export default ___CSS_LOADER_EXPORT___;
